"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DepartmentsDto = void 0;
class DepartmentsDto {
    constructor(params) {
        this.name = "";
        this.hours = "";
        this.phoneNumber = "";
        this.emailAddress = "";
        this.emailFormat = "";
        this.websiteUrl = "";
        this.createdAt = "";
        this.updatedAt = "";
        this.departmentType = "";
        this.customImageContentType = "";
        this.customImageFileName = "";
        this.customImageFileSize = "";
        this.customImageUpdatedAt = "";
        this.address = "";
        this.phoneFieldText = "";
        this.messageFieldText = "";
        this.extra1Name = "";
        this.extra1Url = "";
        this.extra2Name = "";
        this.extra2Url = "";
        this.extra3Name = "";
        this.extra3Url = "";
        this.formUrl = "";
        this.serviceTypes = "";
        this.hideTitleOverlay = "";
        if (!params) {
            return;
        }
        this.id = params.id;
        this.locationId = params.locationId;
        this.imageId = params.imageId;
        this.name = params.name;
        this.hours = params.hours;
        this.phoneNumber = params.phoneNumber;
        this.emailAddress = params.emailAddress;
        this.emailFormat = params.emailFormat;
        this.websiteUrl = params.websiteUrl;
        this.createdAt = params.createdAt;
        this.updatedAt = params.updatedAt;
        this.departmentType = params.departmentType;
        this.customImageFileName = params.customImageFileName;
        this.customImageContentType = params.customImageContentType;
        this.customImageFileSize = params.customImageFileSize;
        this.customImageUpdatedAt = params.customImageUpdatedAt;
        this.address = params.address;
        this.phoneFieldText = params.phoneFieldText;
        this.messageFieldText = params.messageFieldText;
        this.extra1Name = params.extra1Name;
        this.extra1Url = params.extra1Url;
        this.extra2Name = params.extra2Name;
        this.extra2Url = params.extra2Url;
        this.extra3Name = params.extra3Name;
        this.extra3Url = params.extra3Url;
        this.formUrl = params.formUrl;
        this.serviceTypes = params.serviceTypes;
        this.hideTitleOverlay = params.hideTitleOverlay;
    }
}
exports.DepartmentsDto = DepartmentsDto;
//# sourceMappingURL=DepartmentsDto.js.map